/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-28 12:55:15
 * @LastEditTime: 2022-01-28 21:09:08
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/page/HsbMarketPlatform/rule/index.jsx
 */
import { Button, message } from 'antd';
import React, { useState, useRef } from 'react'
import AuthButton from '../../../components/AuthButton/AuthButton';
import PageWrap from '../../../components/PageWrap'
import TableHelper from '../../../components/TableHelper'
import { fetchHSBMarketPlatformRuleList, fetchHSBMarketPlatformRuleSyncData } from "../../../services/HSBMarketPlatform";
import { findDict, formatTime } from '../../../utils';
import HsbMarketPlatformRuleDetail from './detail';
import {commonIsMap} from "../../../axios/dictionaries";
const HsbMarketPlatformRule = (props) => {
    const [loading, setLoading] = useState(false);
    let HsbMarketPlatformRuleDetailRef = null 
    let TableHelperRef = useRef() 

    const handleSyncData = () => {
        postSyncData().then(() => {
            TableHelperRef.current.postDataSource()
        })
    }
    const postSyncData = () => {
        setLoading(true)
        return fetchHSBMarketPlatformRuleSyncData().then(res => {
            message.success('同步成功')
        }).finally(() => {
            setLoading(false)
        })
    }
    const mapClrgMode = [
        { title: '翻盘式', value: "1" },
        { title: '滚动式', value: "2" },
        { title: '时间自定义式', value: "3" },
    ]
    const mapClrgMtdcd = [
        { title: '固定金额', value: "1" },
        { title: '固定比例', value: "2" },
        { title: '先固定金额再比例', value: "3" },
    ]
    const mapSubAccCyc = [
        { title: '日', value: "1" },
        { title: '月', value: "2" },
        { title: '月末', value: "3" },

    ]

    const searchOptions = [
        { key: 'subAccCyc', type: 'select', options: mapSubAccCyc, placeholder: '分账周期' },
        { key: 'clrgMtdcd', type: 'select', options: mapClrgMtdcd, placeholder: '清算方式代码' },
        { key: 'clrgMode', type: 'select', options: mapClrgMode, placeholder: '清算模式' },
        { key: 'keyword', type: 'input', placeholder: '关键字搜索（编号及名称）'},
    ]

    const columns = [
        { title: '规则名称', dataIndex: 'ruleNm', width: 200, },
        { title: '分账周期 ', dataIndex: 'subAccCyc',width: 80, render: (text) => {
                return findDict(mapSubAccCyc, text).title
            }},
        { title: '清算模式', dataIndex: 'clrgMode',width: 100, render: (text) => {
            return findDict(mapClrgMode, text).title
        } },
        { title: '清算后延天数', dataIndex: 'clrgDlayDys',width: 100, },
        { title: '清算方式代码', dataIndex: 'clrgMtdcd',width: 150, render: (text) => {
            return findDict(mapClrgMtdcd, text).title
        }},
        { title: '清算规则编号', dataIndex: 'clrgRuleId',width: 150, },
        { title: '生效日期', dataIndex: 'efdt',width: 100, },
        { title: '失效日期', dataIndex: 'expdt',width: 100, },
        { title: '同步时间', dataIndex: 'updateTime', width: 140, render: formatTime},
        { title: '规则描述', dataIndex: 'ruleDsc', },
        { title: '操作', dataIndex: 'actions', width: 60, fixed: 'right', render: (text, record) => {
            return <React.Fragment>
                <AuthButton authkey="h-7-4">
                    <a onClick={() =>HsbMarketPlatformRuleDetailRef.open(record.id)}>详情</a>
                </AuthButton>
            </React.Fragment>
        } }
    ]
    return (
        <PageWrap>
            <TableHelper ref={TableHelperRef} searchOptions={searchOptions} columns={columns} scroll={{ x: 2000 }} request={fetchHSBMarketPlatformRuleList} >
                <div slot="search">
                    <AuthButton authkey="h-7-5">
                        <Button type="primary" loading={loading} onClick={handleSyncData}>同步数据</Button>
                    </AuthButton>
                </div>
            </TableHelper>
            <HsbMarketPlatformRuleDetail getRef={ref => HsbMarketPlatformRuleDetailRef = ref} />
        </PageWrap>
    )
}

export default HsbMarketPlatformRule 


// WEBPACK FOOTER //
// ./src/page/HsbMarketPlatform/rule/index.jsx